import React, { useState } from 'react'
import { useAuth } from '../Context/Auth'
import useForm from '../Utils/useForm'
import { validateSignup } from '../Utils/validate'
import { Link, useHistory } from 'react-router-dom'

import { FlexboxGrid, Button, ButtonToolbar, Form, FormGroup, FormControl, ControlLabel, Panel } from 'rsuite'
import '../Components/Styles/forms.css'

export default function Signup () {
  const [username, setUsername] = useState(null)
  const [email, setEmail] = useState(null)
  const [password, setPassword] = useState(null)

  const { signup, updateProfile } = useAuth()
  const { handleChange, handleSubmit, values, errors } = useForm(handleFormSubmit, validateSignup)

  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const history = useHistory()

  // function to handle form submit after fields are validated
  async function handleFormSubmit () {
    setUsername(values.username)
    setEmail(values.email)
    setPassword(values.password)
    console.log(email, password, username)
    try {
      setError('')
      setLoading(true)
      await signup(values.email, values.password)
      updateProfile(values.username)
      history.push('/')
    } catch (error) {
      // Handle Errors here.
      setError('Failed to create Account')
      const errorCode = error.code
      const errorMessage = error.message
      setError('Failed to create Account' + errorMessage)
      console.log(errorCode + ' ' + errorMessage)
    }
    setLoading(false)
  }

  return (
    <FlexboxGrid className='bg'>
      <FlexboxGrid.Item colspan={12}>
        <div id='title' className='nav-text'>
          <span style={{ fontWeight: 'bold', fontSize: '20px', marginBottom: '-5px' }}>TAITO</span>
          <span style={{ fontWeight: '150', fontSize: '20px', marginBottom: '5px' }}>TRAINING</span>
        </div>
        <FlexboxGrid.Item className='grid'>
          <h2 className='header'>Sign up to start</h2>
          <Form fluid onSubmit={handleSubmit} noValidate className='form'>
            {error && <div className='error'>{error}</div>}
            <FormGroup>
              <ControlLabel>Name</ControlLabel>
              <FormControl
                type='text'
                name='username'
                onChange={(e) => handleChange('username', e)}
                values={values.username} placeholder='First and last name'
                className='input'
              />
              {errors.username && <div className='error'>{errors.username}</div>}
            </FormGroup>
            <FormGroup>
              <ControlLabel>Email</ControlLabel>
              <FormControl
                type='email'
                name='email'
                onChange={(e) => handleChange('email', e)}
                values={values.email} placeholder='Your email address'
                className='input'
              />
              {errors.email && <div className='error'>{errors.email}</div>}
            </FormGroup>
            <FormGroup>
              <ControlLabel>Password</ControlLabel>
              <FormControl
                type='password'
                name='password' onChange={(e) => handleChange('password', e)}
                values={values.password} placeholder='At least 6 characters long'
                className='input'
              />
              {errors.password && <div className='error'>{errors.password}</div>}
            </FormGroup>
            <FormGroup>
              <ButtonToolbar>
                <Button className='button' disabled={loading} type='submit' block>Sign up</Button>
              </ButtonToolbar>
            </FormGroup>
            <FormGroup className='linkGroup'>
              Already have an account? <Link className='link' to='/login'>Log in</Link>
            </FormGroup>
          </Form>
        </FlexboxGrid.Item>
      </FlexboxGrid.Item>

      <FlexboxGrid.Item colspan={12}>
        <Panel className='bgImage' style={{ backgroundImage: 'url("Images/LoginBg.svg")' }} />
      </FlexboxGrid.Item>
    </FlexboxGrid>
  )
}
